import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import withMobileDialog from "@material-ui/core/withMobileDialog";

import { EmptyRecord } from "../../utils/PageUtility";
import RecordPagination from "../../utils/RecordsPagination";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";

const CustomTableCell = withStyles((theme) => ({
  head: {
    color: "#04137b",
    fontSize: "14px",
    fontWeight: "lighter",
    padding: "20px",
  },
  body: {
    fontSize: 14,
    padding: "20px",
  },
}))(TableCell);

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  tableStyle: {
    padding: 0,
  },
};

const MyInvoicesTableStructure = ({ classes, records, pageIndex }) => (
  <Table className={classes.table} aria-labelledby="tableTitle">
    <TableHead className={classes.negativeColor} color="primary">
      <TableRow>
        <CustomTableCell>S/N</CustomTableCell>
        <CustomTableCell>Invoice</CustomTableCell>
        <CustomTableCell>Invoice Date</CustomTableCell>
        <CustomTableCell>Amount </CustomTableCell>
        <CustomTableCell>Amount Paid </CustomTableCell>
        <CustomTableCell>Airport</CustomTableCell>
        <CustomTableCell>Airline</CustomTableCell>
        <CustomTableCell>Payment Date</CustomTableCell>
        <CustomTableCell>Status</CustomTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {records &&
        records.map((item, key) => {
          return (
            <TableRow hover key={key}>
              <CustomTableCell component="th">
                {pageIndex + key}
              </CustomTableCell>
              <CustomTableCell>{item.InvoiceNumber}</CustomTableCell>
              <CustomTableCell>
                {item.InvoiceDate
                  ? appHelpers.formatDate(item.InvoiceDate, "MMM DD, YYYY")
                  : ""}
              </CustomTableCell>
              <CustomTableCell>
                {item.CurrencyCode}{" "}
                {appHelpers.numberWithCommas(item.Amount)}
              </CustomTableCell>
              <CustomTableCell>
                {item.CurrencyCode}{" "}
                {appHelpers.numberWithCommas(item.AmountPaid)}
              </CustomTableCell>
              <CustomTableCell>{item.Location}</CustomTableCell>
              <CustomTableCell>{item.AirlineName}</CustomTableCell>
              <CustomTableCell>
                {item.PaymentDate
                  ? appHelpers.formatDate(item.PaymentDate, "MMM DD, YYYY")
                  : ""}
              </CustomTableCell>
              <CustomTableCell>
                {item.Status === 0 && (
                  <span style={{ color: "#828282" }}>Pending</span>
                )}
                {item.Status === 1 && (
                  <span style={{ color: "#ff9800" }}>Initiated</span>
                )}
                {item.Status === 2 && (
                  <span style={{ color: "#66bb6a" }}>Approved</span>
                )}
                {item.Status === 3 && (
                  <span style={{ color: "#dd2735" }}>Rejected</span>
                )}
              </CustomTableCell>
            </TableRow>
          );
        })}
    </TableBody>
  </Table>
);

class MyInvoicesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      flight: false,
    };
  }

  handleClickOpen = (flight) => {
    this.setState({ open: true });
    this.setState({ flight });
    this.props.fetchFlightPassengers(flight.Id);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      classes,
      searchError,
      user,
      records,
      fetchRecords,
      totalCounts,
      pageSize,
      currentPage,
    } = this.props;

    const index = pageSize * (currentPage - 1) + 1;

    if (totalCounts === 0)
      return <EmptyRecord message={"No invoice record!"} />;
    if (searchError) return <EmptyRecord message={searchError} />;
    return (
      <div>
        <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
          <RecordPagination
            fetchMore={fetchRecords}
            totalCount={totalCounts}
            pageSize={pageSize}
            currentPage={currentPage}
            target={
              <MyInvoicesTableStructure
                pageSize={pageSize}
                currentPage={currentPage}
                records={records}
                classes={classes}
                user={user}
                pageIndex={index}
              />
            }
          />
        </div>
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(MyInvoicesTable));



// WEBPACK FOOTER //
// ./src/Regional-Views/InvoiceApproval/myInvoicesTable.js